export function extractQueryFields<T extends Record<string, string>>(properties: T): string[] {
  return (Object.keys(properties) as Array<keyof T>)
    .filter(key =>
      String(key)
        .toLowerCase()
        .includes('query')
    )
    .map(key => properties[key]);
}

export function extractApiProperties<T extends Record<string, any>>(properties: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(properties).filter(([key]) => !key.toLowerCase().includes('query'))
  ) as Partial<T>;
}
